import { useState } from 'react';

export function NametagInput({
  id,
  value,
  onChange,
  suggestions,
  placeholder,
  className,
  wrapperClassName,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  suggestions: readonly string[];
  placeholder?: string;
  className?: string;
  wrapperClassName?: string;
}) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const options = suggestions.filter((name) => name !== value);
  const expanded = open && options.length > 0;
  const listId = `${id}-listbox`;

  const pick = (name: string) => {
    onChange(name);
    setOpen(false);
    setActive(-1);
  };

  return (
    <div className={['nametag-combo', wrapperClassName].filter(Boolean).join(' ')}>
      <input
        id={id}
        className={className}
        type="text"
        role="combobox"
        aria-autocomplete="list"
        aria-expanded={expanded}
        aria-controls={listId}
        aria-activedescendant={expanded && active >= 0 ? `${listId}-${active}` : undefined}
        value={value}
        placeholder={placeholder}
        maxLength={32}
        autoComplete="off"
        onChange={(event) => {
          onChange(event.target.value);
          setOpen(true);
          setActive(-1);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onKeyDown={(event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            if (!options.length) return;
            event.preventDefault();
            setOpen(true);
            const step = event.key === 'ArrowDown' ? 1 : -1;
            setActive((current) => (current + step + options.length) % options.length);
          } else if (event.key === 'Enter' && expanded && active >= 0) {
            event.preventDefault();
            pick(options[active]!);
          } else if (event.key === 'Escape' && expanded) {
            event.preventDefault();
            setOpen(false);
          }
        }}
      />
      {expanded ? (
        <ul id={listId} role="listbox" className="nametag-combo__list">
          {options.map((name, index) => (
            <li
              key={name}
              id={`${listId}-${index}`}
              role="option"
              aria-selected={index === active}
              className="nametag-combo__option"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => pick(name)}
            >
              {name}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
